const { $, rz } = window;

export function getCurTheme() {
  const curTheme = $("html").attr("data-theme");
  return curTheme;
}

export function replaceThemeElements(theme) {
  const curTheme = theme || getCurTheme();
  const bgcontainer = $("#background-container");

  // replace button-theme icon
  $("button#set-theme > i").attr("class", (curTheme === "light" ? "fa fa-moon-o" : "fa fa-sun-o"));

  if (curTheme === "dark") {
    // replace logo-image:
    $("img#gclogo[src*='gc-logo']").attr("src", "/img/general/gc-logo-w-48.png");
    // replace background multiple-mode:
    if (bgcontainer[0]) {
      let bgstyle = $(bgcontainer[0]).attr("style");
      bgstyle = bgstyle.replace(/\s/g, "").replace("background-color:rgba(240,240,240,0.9);background-blend-mode:color-dodge", "background-color:rgba(50,50,50,1);background-blend-mode:multiply");
      $(bgcontainer[0]).attr("style", bgstyle);
    }
  }
  else {
    // replace logo-image:
    $("img#gclogo[src*='gc-logo']").attr("src", "/img/general/gc-logo-b-48.png");
    // replace background multiple-mode:
    if (bgcontainer[0]) {
      let bgstyle = $(bgcontainer[0]).attr("style");
      bgstyle = bgstyle.replace(/\s/g, "").replace("background-color:rgba(50,50,50,1);background-blend-mode:multiply", "background-color:rgba(240,240,240,0.9);background-blend-mode:color-dodge");
      $(bgcontainer[0]).attr("style", bgstyle);
    }
  }

  return curTheme;
}

export default async function changeTheme(theme) {
  const data = { theme: theme || (getCurTheme() === "dark" ? "light" : "dark") };
  rz.log({message: "Change Theme -> " + data.theme, caller: "SSR.theme.changeTheme()"});
  const res = await fetch("/api/changetheme", {method: "POST", body: JSON.stringify(data), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
  let ans = await res.json();
  if (!ans || !ans.result || !ans.theme) {
    if (rz.isString(ans) || !ans) ans = {ans};
    rz.log({message: "Cant change Theme on Server! Response:\n" + JSON.stringify(ans), caller: "SSR.theme.changeTheme()"});
    return false;
  }

  // Call react-functions in miniapps
  if (window.changethemeglobal) {
    window.changethemeglobal.forEach((fn) => {
      try { fn(ans.theme) }
      catch (err) { console.error(err) }
    });
  }

  // change curstyle fast
  $("html").attr("data-theme", ans.theme);
  const linkrevealtheme = $("link#revealtheme");
  if (linkrevealtheme[0]) $(linkrevealtheme[0]).attr("href", "/css/reveal/theme/" + ans.theme.replace("dark", "black").replace("light", "white") + ".css").attr("themename", ans.theme);

  replaceThemeElements(ans.theme);
}
